

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";

// ----------------Financial Year-----------

export const FinancialYearDDLAPI = createAsyncThunk("FinancialYearDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_FinancialYear_Select?M_TableUserMasterID=${M_TableUserMasterID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const FinancialYearDDLSlice = createSlice({
    name: "FinancialYearDDL",
    initialState: {
        isLoading: false,
        FinancialYearData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(FinancialYearDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(FinancialYearDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.FinancialYearData = action.payload;
        });
        builder.addCase(FinancialYearDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.FinancialYearData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const FinancialYearDDLReducer = FinancialYearDDLSlice.reducer

// ----------------Month DDL-----------

export const MonthDDLAPI = createAsyncThunk("MonthDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        FinancialYear,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_Months_Select?M_TableUserMasterID=${M_TableUserMasterID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {

            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MonthDDLSlice = createSlice({
    name: "MonthDDL",
    initialState: {
        isLoading: false,
        MonthData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MonthDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MonthDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.MonthData = action.payload;
        });
        builder.addCase(MonthDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.MonthData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const MonthDDLReducer = MonthDDLSlice.reducer


export const ProjectNameDDLAPI = createAsyncThunk("ProjectNameDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Project_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ProjectNameDDLSlice = createSlice({
    name: "ProjectNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ProjectNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ProjectNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(ProjectNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const ProjectNameDDLReducer = ProjectNameDDLSlice.reducer


// 
export const DesignationNameDDLAPI = createAsyncThunk("DesignationNameDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_DesignationMaster?Flag=${Flag}&M_TableUserMasterID=${M_TableUserMasterID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DesignationNameDDLSlice = createSlice({
    name: "DesignationNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DesignationNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DesignationNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(DesignationNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const DesignationNameDDLReducer = DesignationNameDDLSlice.reducer


export const NameOfAgencyDDLAPI = createAsyncThunk("NameOfAgencyDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Agency_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const NameOfAgencyDDLSlice = createSlice({
    name: "NameOfAgencyDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(NameOfAgencyDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(NameOfAgencyDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(NameOfAgencyDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const NameOfAgencyDDLReducer = NameOfAgencyDDLSlice.reducer

// --------------------Department Name----------------------

export const DepartmentNameDDLAPI = createAsyncThunk("DepartmentNameDDL", async ({ data }) => {
    const {
        UserID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_DepartmentMaster?Flag=${Flag}&M_TableUserMasterID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DepartmentNameDDLSlice = createSlice({
    name: "DepartmentNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DepartmentNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DepartmentNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(DepartmentNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const DepartmentNameDDLReducer = DepartmentNameDDLSlice.reducer

// --------------------Gender----------------------

export const GenderDDLAPI = createAsyncThunk("GenderDDL", async ({ data }) => {
    const {
        UserID,
        GroupId,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_IndicatorMaster_Select?GroupId=${GroupId}&UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const GenderDDLSlice = createSlice({
    name: "GenderDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GenderDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GenderDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(GenderDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const GenderDDLReducer = GenderDDLSlice.reducer


// --------------------Role Manager DDL----------------------

export const RoleManagerDDLAPI = createAsyncThunk("RoleManagerDDL", async ({ data }) => {
    const {
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_RoleManager?UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const RoleManagerDDLSlice = createSlice({
    name: "RoleManagerDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RoleManagerDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RoleManagerDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(RoleManagerDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const RoleManagerDDLReducer = RoleManagerDDLSlice.reducer

// --------------------Employee Name DDL----------------------

export const EmployeeNameDDLAPI = createAsyncThunk("EmployeeNameDDL", async ({ data }) => {
    const {
        M_DesignationMasterID,
        UserID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_DDL_M_EmployeeMaster?M_DesignationMasterID=${M_DesignationMasterID ? M_DesignationMasterID : '0'}&UserID=${UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EmployeeNameDDLSlice = createSlice({
    name: "EmployeeNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EmployeeNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EmployeeNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(EmployeeNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const EmployeeNameDDLReducer = EmployeeNameDDLSlice.reducer

// --------------------State Name----------------------

export const StateNameDDLAPI = createAsyncThunk("StateNameDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        FinancialYearID,
        MonthsID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_StateName_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}&FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const StateNameDDLSlice = createSlice({
    name: "StateNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(StateNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(StateNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(StateNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const StateNameDDLReducer = StateNameDDLSlice.reducer

// --------------------Regional Office----------------------

export const RegionalOfficeDDLAPI = createAsyncThunk("RegionalOfficeDDL", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_StateNameID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_RegionalOffice_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_StateNameID=${M_StateNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const RegionalOfficeDDLSlice = createSlice({
    name: "RegionalOfficeDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(RegionalOfficeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(RegionalOfficeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(RegionalOfficeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const RegionalOfficeDDLReducer = RegionalOfficeDDLSlice.reducer

// -------------------Field Station Officer----------------------

export const FieldStationOfficerDDLAPI = createAsyncThunk("FieldStationOfficerDDL", async ({ data }) => {
    const {
        M_RegionalOfficeID,
        M_TableUserMasterID,
        Flag,
        MonthsID,
        FinancialYearID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_FieldStationOfficer_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_RegionalOfficeID=${M_RegionalOfficeID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const FieldStationOfficerDDLSlice = createSlice({
    name: "FieldStationOfficerDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(FieldStationOfficerDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(FieldStationOfficerDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(FieldStationOfficerDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const FieldStationOfficerDDLReducer = FieldStationOfficerDDLSlice.reducer

// -------------------District DDL----------------------

export const DistrictDDLAPI = createAsyncThunk("DistrictDDL", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        M_StateNameID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_DistrictName_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_StateNameID=${M_StateNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DistrictDDLSlice = createSlice({
    name: "DistrictDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DistrictDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DistrictDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(DistrictDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const DistrictDDLReducer = DistrictDDLSlice.reducer

// -------------------Surveyor Name ------------------------

export const SurveyorNameDDLAPI = createAsyncThunk("SurveyorNameDDL", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Surveyor_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SurveyorNameDDLSlice = createSlice({
    name: "SurveyorNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SurveyorNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SurveyorNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(SurveyorNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const SurveyorNameDDLReducer = SurveyorNameDDLSlice.reducer


// -------------------Unit ------------------------

export const UnitDDLAPI = createAsyncThunk("UnitDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Unit_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const UnitDDLSlice = createSlice({
    name: "UnitDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UnitDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(UnitDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(UnitDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const UnitDDLReducer = UnitDDLSlice.reducer

// -------------------Taluka ------------------------


export const TalukaDDLAPI = createAsyncThunk("TalukaDDL", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        M_StateNameID,
        M_DistrictNameID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_TalukaName_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_StateNameID=${M_StateNameID}&M_DistrictNameID=${M_DistrictNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const TalukaDDLSlice = createSlice({
    name: "TalukaDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TalukaDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(TalukaDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(TalukaDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const TalukaDDLReducer = TalukaDDLSlice.reducer

// -------------------Village ------------------------

export const VillageDDLAPI = createAsyncThunk("VillageDDL", async ({ data }) => {
    const {
        FinancialYearID,
        MonthsID,
        M_BeneficiaryDetailsID,
        M_StateNameID,
        M_DistrictNameID,
        M_TalukaNameID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_VillageName_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_StateNameID=${M_StateNameID}&M_DistrictNameID=${M_DistrictNameID}&M_TalukaNameID=${M_TalukaNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const VillageDDLSlice = createSlice({
    name: "VillageDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(VillageDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(VillageDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(VillageDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const VillageDDLReducer = VillageDDLSlice.reducer

// -------------------Beneficiary Name ------------------------

export const BeneficiaryNameDDLAPI = createAsyncThunk("BeneficiaryNameDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token,
        MonthsID,
        FinancialYearID, } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Beneficiary_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const BeneficiaryNameDDLSlice = createSlice({
    name: "BeneficiaryNameDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(BeneficiaryNameDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(BeneficiaryNameDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(BeneficiaryNameDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const BeneficiaryNameDDLReducer = BeneficiaryNameDDLSlice.reducer

// -------------------Cluster ------------------------

export const ClusterDDLAPI = createAsyncThunk("ClusterDDL", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        M_VillageNameID,
        M_TableUserMasterID,
        Flag,
        MonthsID,
        FinancialYearID,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_SurveyorInfo_Cluster_Select?FinancialYearID=${FinancialYearID}&MonthsID=${MonthsID}&M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_VillageNameID=${M_VillageNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ClusterDDLSlice = createSlice({
    name: "ClusterDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ClusterDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ClusterDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(ClusterDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const ClusterDDLReducer = ClusterDDLSlice.reducer

// -------------------Agency ------------------------

export const ImplementingAgencyDDLAPI = createAsyncThunk("ImplementingAgencyDDL", async ({ data }) => {
    const {

        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Agency_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ImplementingAgencyDDLSlice = createSlice({
    name: "ImplementingAgencyDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ImplementingAgencyDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ImplementingAgencyDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(ImplementingAgencyDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const ImplementingAgencyDDLReducer = ImplementingAgencyDDLSlice.reducer

// -------------------Type of Monitoring ------------------------

export const TypeofMonitoringDDLAPI = createAsyncThunk("TypeofMonitoringDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_Indicator_MonitoringType_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const TypeofMonitoringDDLSlice = createSlice({
    name: "TypeofMonitoringDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(TypeofMonitoringDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(TypeofMonitoringDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(TypeofMonitoringDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const TypeofMonitoringDDLReducer = TypeofMonitoringDDLSlice.reducer

// -------------------Age DDL ------------------------

export const AgeDDLAPI = createAsyncThunk("AgeDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_Age_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const AgeDDLSlice = createSlice({
    name: "AgeDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(AgeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(AgeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(AgeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const AgeDDLReducer = AgeDDLSlice.reducer

// -------------------Education DDL ------------------------

export const EducationDDLAPI = createAsyncThunk("EducationDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_Education_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const EducationDDLSlice = createSlice({
    name: "EducationDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EducationDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EducationDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(EducationDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const EducationDDLReducer = EducationDDLSlice.reducer

// -------------------Member in HH DDL ------------------------

export const MemberInHHDDLAPI = createAsyncThunk("MemberInHHDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_MembersInHH_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const MemberInHHDDLSlice = createSlice({
    name: "MemberInHHDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(MemberInHHDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(MemberInHHDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(MemberInHHDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const MemberInHHDDLReducer = MemberInHHDDLSlice.reducer

// -------------------Livelihood Source DDL ------------------------

export const LivelihoodSourceDDLAPI = createAsyncThunk("LivelihoodSourceDDL", async ({ data }) => {
    const {
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_LiveliHood_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const LivelihoodSourceDDLSlice = createSlice({
    name: "LivelihoodSourceDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(LivelihoodSourceDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(LivelihoodSourceDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(LivelihoodSourceDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const LivelihoodSourceDDLReducer = LivelihoodSourceDDLSlice.reducer

// -------------------Plot Code DDL ------------------------

export const PlotCodeDDLAPI = createAsyncThunk("PlotCodeDDL", async ({ data }) => {
    const {
        M_BeneficiaryDetailsID,
        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_DDL_M_BeneficiaryWisePlot_Select?M_BeneficiaryDetailsID=${M_BeneficiaryDetailsID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PlotCodeDDLSlice = createSlice({
    name: "PlotCodeDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlotCodeDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PlotCodeDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(PlotCodeDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const PlotCodeDDLReducer = PlotCodeDDLSlice.reducer

// ------------------Planting Material Received From DDL ------------------------

export const PlantingMaterialReceivedFromDDLAPI = createAsyncThunk("PlantingMaterialReceivedFromDDL", async ({ data }) => {
    const {

        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_Received_From_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PlantingMaterialReceivedFromDDLSlice = createSlice({
    name: "PlantingMaterialReceivedFromDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantingMaterialReceivedFromDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PlantingMaterialReceivedFromDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(PlantingMaterialReceivedFromDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const PlantingMaterialReceivedFromDDLReducer = PlantingMaterialReceivedFromDDLSlice.reducer

// ------------------ Planting Material Payment DDL ------------------------

export const PlantingMaterialPaymentDDLAPI = createAsyncThunk("PlantingMaterialPaymentDDL", async ({ data }) => {
    const {

        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_MaterialPayment_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PlantingMaterialPaymentDDLSlice = createSlice({
    name: "PlantingMaterialPaymentDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantingMaterialPaymentDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PlantingMaterialPaymentDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(PlantingMaterialPaymentDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const PlantingMaterialPaymentDDLReducer = PlantingMaterialPaymentDDLSlice.reducer

// ------------------ Planting Material Packaging DDL ------------------------

export const PlantingMaterialPackagingDDLAPI = createAsyncThunk("PlantingMaterialPackagingDDL", async ({ data }) => {
    const {

        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_PlanMaterialPackaging_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PlantingMaterialPackagingDDLSlice = createSlice({
    name: "PlantingMaterialPackagingDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PlantingMaterialPackagingDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PlantingMaterialPackagingDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(PlantingMaterialPackagingDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const PlantingMaterialPackagingDDLReducer = PlantingMaterialPackagingDDLSlice.reducer

// ------------------ Get_APK_DDL_CommanPlantionDetails_Select DDL ------------------------

export const CommanPlantionDetailsDDLAPI = createAsyncThunk("CommanPlantionDetailsDDL", async ({ data }) => {
    const {
        setReasonForDeath,
        M_TableUserMasterID,
        Flag,
        token,
        setPlantDDLData,
        setIntercropsDDLData,
        setStatusLandDDLData,
        setOwnershipDDLData,
        setLandPreparationDDLData,
        setCompletelyReplacedDDLData,
        setQualityAndStatus,
        setReplacedDeadSaplings,
        setTrainingFrequencyDDLData,
        setFrenceDDLData,
        setFrequencyPesticidesDDLData,
        setFrequencyforFertilizerData,
        setWeedManagementPracticesData,
        setCropName } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/CommonDLLData/Get_APK_DDL_CommanPlantionDetails_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                if (Flag == "ReasonForDeath") {
                    setReasonForDeath(result.data)
                } if (Flag == "DistanceMaintained") {
                    setPlantDDLData(result.data)
                } if (Flag == "StatusOfIntercrops") {
                    setIntercropsDDLData(result.data)
                } if (Flag == "LandUsedForRubberPlantation") {
                    setStatusLandDDLData(result.data)
                } if (Flag == "Ownership") {
                    setOwnershipDDLData(result.data)
                } if (Flag == "LandPreparation") {
                    setLandPreparationDDLData(result.data)
                } if (Flag == "CompletelyReplaced") {
                    setCompletelyReplacedDDLData(result.data)
                } if (Flag == "CropName") {
                    setCropName(result.data)
                } if (Flag == "QualityAndStatus") {
                    setQualityAndStatus(result.data)
                } if (Flag == "ReplacedDeadSaplings") {
                    setReplacedDeadSaplings(result.data)
                } if (Flag == "FrequencyOfTraining") {
                    setTrainingFrequencyDDLData(result.data)
                } if (Flag == 'Fence') {
                    setFrenceDDLData(result.data)
                } if (Flag == 'Pesticide') {
                    setFrequencyPesticidesDDLData(result.data)
                } if (Flag == 'Fertilizer') {
                    setFrequencyforFertilizerData(result.data)
                } if (Flag == 'WeedManagement') {
                    setWeedManagementPracticesData(result.data)
                }
                return result.data
            } else {
                return result
            }
        })
})

const CommanPlantionDetailsDDLSlice = createSlice({
    name: "CommanPlantionDetailsDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CommanPlantionDetailsDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(CommanPlantionDetailsDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(CommanPlantionDetailsDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const CommanPlantionDetailsDDLReducer = CommanPlantionDetailsDDLSlice.reducer

// ------------------ Planting Material Packaging DDL ------------------------

export const ConditionDDLAPI = createAsyncThunk("ConditionDDL", async ({ data }) => {
    const {

        M_TableUserMasterID,
        Flag,
        token } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/CommonDLLData/Get_A_DDL_M_Indicator_Condition_Select?M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const ConditionDDLSlice = createSlice({
    name: "ConditionDDL",
    initialState: {
        isLoading: false,
        DDLData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(ConditionDDLAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(ConditionDDLAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.DDLData = action.payload;
        });
        builder.addCase(ConditionDDLAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.DDLData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const ConditionDDLReducer = ConditionDDLSlice.reducer





